import { Account } from '@/domain/usecases'
import { upgradeRequestService } from '@/data/services/upgrade/upgrade-service'

/**
 * Loads upgrade request settings for company manager
 * Fetches company upgrade request configuration
 */
export async function loadCompanyManagerUpgradeRequest(account: Account.Model) {
  const upgradeSettings = await upgradeRequestService.fetchSettings(account.company.uniqueId)

  return {
    ...upgradeSettings
  }
}
